export default __webpack_public_path__ + "static/char-s-50-ko-7eae5165e152c4828ae5a40f39bca3ed.webp";